import * as React from 'react';
import { Alert } from 'antd';
import { IAlertProps, IAlertTypes } from './entities';
import styles from './assets/style.scss';

const BCAlert = (props: IAlertProps) => {
	styles;

	const onClose = (e: React.FormEvent<any>) => {
		props.onClose?.({
			event: e
		});
	};

	return (
		<Alert
			message={props.message}
			description={props.description}
			banner={props.banner}
			closable={props.closable}
			closeIcon={props.closeIcon}
			showIcon={props.showIcon}
			icon={props.icon}
			type={props.type}
			onClose={onClose}
			style={props.style}
			className={props.className}
			action={props.action}
		/>
	);
};

export default BCAlert;
export { IAlertProps, IAlertTypes };
